// Accent color themes for resumes. Each template has its own default,
// but users can override with any of these.
export const COLOR_THEMES = [
  { id: 'navy', name: 'Midnight Navy', color: '#0A0F1C' },
  { id: 'slate', name: 'Graphite', color: '#1E293B' },
  { id: 'rust', name: 'Burnt Rust', color: '#C2410C' },
  { id: 'emerald', name: 'Emerald', color: '#0F766E' },
  { id: 'royal', name: 'Royal Blue', color: '#1D4ED8' },
  { id: 'violet', name: 'Violet', color: '#6D28D9' },
  { id: 'cyan', name: 'Ocean', color: '#0369A1' },
  { id: 'rose', name: 'Crimson', color: '#BE123C' },
  { id: 'forest', name: 'Forest', color: '#166534' },
  { id: 'amber', name: 'Amber', color: '#B45309' },
  { id: 'plum', name: 'Plum', color: '#86198F' },
  { id: 'teal', name: 'Teal', color: '#0D9488' },
];
